/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {MasiveTicket} from '../form/MasiveDownloadTicketPDF'
import {TableLaundryOperation} from './columns'
const TableLaundryOperationWrapper = () => {
  const {isAllowed} = useLavanderia()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Órdenes</Tab>
            {isAllowed('MASIVO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Generar masiva de tickets</Tab>
            )}
          </TabList>
          <TabPanel>
            <TableLaundryOperation />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveTicket />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableLaundryOperationWrapper}
